module.exports = __webpack_public_path__ + "static/media/GodII.93cfe0a3.wav";